import React, { useImperativeHandle } from 'react';
import { Form } from 'react-bootstrap';
import NumberFormat from 'react-number-format';
import '../sharedFormControl.css'

const Number = (props, ref) => {

    useImperativeHandle(ref, () => ({ isZipValid }), [props.value]);

    const isZipValid = () => {

        if (props.required && props.value && props.value.length === 5)
            return true;
        else if (props.required && (!props.value || (props.value && props.value.length !== 5)))
            return false;

        return true;

    }

    const onChange = (val) => {

        if (props.onChange)
            props.onChange(props.objectKey, val);

    }

    return (
        <React.Fragment>
            <fieldset className={`${props.zeroMargin ? 'default-fieldset mb-0' : 'default-fieldset'} ${props.disabled ? 'disabled-form-field' : ''}`}>
                {!props.hideLegend ? <legend className='default-fieldset-label'>{props.label ? props.label : ''}</legend> : null}
                <NumberFormat
                    className={props.className ? props.className : ''}
                    required={props.required}
                    isAllowed={props.isAllowed ? props.isAllowed : undefined}
                    fixedDecimalScale={props.fixedDecimalScale ? true : false}
                    allowLeadingZeros={props.allowLeadingZeros ? true : false}
                    name={props.objectKey}
                    prefix={props.prefix ? props.prefix : ''}
                    suffix={props.suffix ? props.suffix : ''}
                    thousandSeparator={props.thousandSeparator ? props.thousandSeparator : false}
                    decimalScale={props.decimalScale ? props.decimalScale : undefined}
                    onValueChange={(values) => onChange(values.value)}
                    allowNegative={props.allowNegative ? props.allowNegative : false}
                    format={props.format ? props.format : undefined}
                    disabled={props.disabled}
                    placeholder={props.placeholder}
                    onBlur={() => { if (props.onBlur) props.onBlur(props.objectKey) }}
                    value={props.value || props.value === 0 ? props.value : '' }
                />
            </fieldset>
            {
                !props.isZipCodeInput ? <Form.Control.Feedback type="invalid">
                    {props.errorMessage ? props.errorMessage : `Please enter a valid ${props.name}.`}
                </Form.Control.Feedback> : null
            }
            {props.isZipCodeInput && props.validated && props.required && !isZipValid() ? <span className='input-error-message'>{props.errorMessage ? props.errorMessage : `Please enter a valid ${props.name}.`}</span> : null}
        </React.Fragment>
    )

}

export default React.forwardRef(Number);